import React, { useRef } from 'react';
import styled from 'styled-components';


const ContactContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: lightgrey;
    padding: 50px 0px;

    margin-bottom: 20px;
    & form{

   `

function Contact(props) {

    return (
        <ContactContainer id="ContactContainer">
            <form action="https://api.web3forms.com/submit" method="POST">
                <input type="hidden" name="access_key" value="76b763b6-c2af-42c9-880b-cae99b48fc9b" />

                <h2>Contact form</h2>
                <div className='input-box'>
                    <label>FullName</label>
                    <input className='feild' type='text' placeholder='Enter your Name' name='name' required />
                </div>
                <div className='input-box'>
                    <label>Email Address</label>
                    <input className='feild' type='text' placeholder='Enter your Email' name='email' required />
                </div>
                <div className='input-box feild'>
                    <label>Message</label>
                    <textarea name='message' id='' className='feild mess' placeholder='Enter your message' required>

                    </textarea>
                </div>
                <input type="hidden" name="redirect" value="https://web3forms.com/success" />

                <button type='submit'>Send Messsage</button>
            </form>

        </ContactContainer>
    )
}

export default Contact
